var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-slide-y-transition',[(_vm.visibility)?_c('main',{staticClass:"password modal"},[_c('section',{staticClass:"password__card"},[_c('Header'),_c(_vm.step,{tag:"component"})],1)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }